<div id="buttons">
    <mat-checkbox
        [attr.data-testid]="'publish_pins_checkbox'"
        matTooltip="Force overrides for all pins"
        id="publish-pins-checkbox"
        (click)="handleForceOverride()"
        [style.display]="((publishPinsToggle$ | async) && (hasPins$ | async)) ? 'inline-block' : 'none'"
        [disabled]="!disableUpdate"
        *ngIf="(isPinOverrideGroupActive$ | async) && (publishPinsToggle$ | async)"
    >
        Force Override
    </mat-checkbox>
    <button
        [attr.data-testid]="'publish_button'"
        mat-raised-button
        matTooltip="Publish Pins"
        id="publish-pins-button"
        (click)="handlePublish()"
        [style.display]="((publishPinsToggle$ | async) && (hasPins$ | async)) ? 'inline-block' : 'none'"
        [disabled]="!disableUpdate"
        *ngIf="(isPinOverrideGroupActive$ | async) && (publishPinsToggle$ | async)">
        Publish Pins
    </button>
    <button
        [attr.data-testid]="'restore_button'"
        mat-raised-button
        matTooltip="Restore Default Pins"
        id="restore-button"
        (click)="handleRestore()"
        [style.display]="(!(publishPinsToggle$ | async) && isRestoreVisible) ? 'inline-block' : 'none'"
        [disabled]="areEditButtonsVisible"
        *ngIf="!(publishPinsToggle$ | async) && areEditButtonsVisible ? 'visible' : 'hidden'">
        Restore Default Pins
    </button>
    <button
        [attr.data-testid]="'update_button'"
        [disabled]="disableUpdate"
        mat-raised-button
        matTooltip="Update Attribute"
        (click)="handleSubmit()"
    >
        Update
    </button>
    <button
        [attr.data-testid]="'cancel_button'"
        [disabled]="disableCancel"
        mat-raised-button
        matTooltip="Cancel"
        (click)="handleCancel()"
    >
        Cancel
    </button>
</div>
